(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const visual = document.querySelector('.cc-hero-v3__visual');
  if (visual && matchMedia('(hover: hover) and (min-width: 900px)').matches && !motion.matches) {
    visual.addEventListener('pointermove', e => {
      const r = visual.getBoundingClientRect();
      visual.style.setProperty('--cc-ry', `${((e.clientX-r.left)/r.width-.5)*8}deg`);
      visual.style.setProperty('--cc-rx', `${(.5-(e.clientY-r.top)/r.height)*5}deg`);
    }, {passive:true});
    visual.addEventListener('pointerleave', () => {visual.style.removeProperty('--cc-rx');visual.style.removeProperty('--cc-ry');});
  }
  document.querySelectorAll('[data-cc-mobile-buy]').forEach(bar => {
    const sectionId = bar.dataset.ccMobileBuy;
    const root = document.getElementById(`MainProduct-${sectionId}`);
    if (!root) return;
    const action = bar.querySelector('[data-cc-buy-action]');
    const price = bar.querySelector('[data-cc-buy-price]');
    const variant = bar.querySelector('[data-cc-buy-variant]');
    let originalVisible = false;
    const getButton = () => document.getElementById(`product-form-${sectionId}`)?.querySelector('[name="add"]');
    const update = () => {
      const original = getButton();
      if (!original) {bar.hidden=true;return;}
      bar.hidden = originalVisible || !matchMedia('(max-width:749px)').matches;
      action.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      const label = original.querySelector('span')?.textContent.trim() || action.textContent.trim();
      if(action.textContent !== label) action.textContent=label;
      const currentPrice = root.querySelector('.price--on-sale .price__sale .price-item--sale') || root.querySelector('.price__regular .price-item--regular');
      price.textContent = currentPrice?.textContent.trim() || '';
      const choices = [...root.querySelectorAll('variant-selects input:checked')].map(el=>el.value);
      root.querySelectorAll('variant-selects select').forEach(el=>choices.push(el.options[el.selectedIndex]?.textContent.trim()));
      variant.textContent = choices.filter(Boolean).join(' · ');
    };
    action.addEventListener('click', () => {
      const original = getButton();
      if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
    });
    const original = getButton();
    if(original) new IntersectionObserver(entries => {originalVisible=entries[0].isIntersecting;update();},{threshold:0.5}).observe(original);
    new MutationObserver(update).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','checked']});
    root.addEventListener('change', update);
    window.addEventListener('resize', update, {passive:true});
    update();
  });
})();
